import { createContext } from 'react';

const PhoneAudioLibContext = createContext();
PhoneAudioLibContext.displayName = 'PhoneAudioLibContext';

export default PhoneAudioLibContext;
